import { Box, Button, Select } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { allUnits } from "../../assets/auditSheetFormats";
import "./audit.scss";

const Instructions = ({
  balanceSheetRefOnClickHandler,
  statementRefOnClickHandler,
  setUnit,
  unit,
}) => {
  return (
    <>
      <Box className="auditContainer">
        <Box className="heading">Instructions to upload</Box>
        <Box className="body">
          <Box className="heading">
            Follow these steps to report SME’s performance
          </Box>
          <Box className="instructions">
            1. Download Balance Sheet Chat template from this{" "}
            <Link
              to={
                "https://docs.google.com/spreadsheets/d/1eFh3R4u_Zy0mBBmfcmLSwp_kc-b6gXJldIuSJypYIhE/edit#gid=0"
              }
              target="_blank"
            >
              <Button variant={"link"} color={"black"}>
                link
              </Button>
            </Link>
          </Box>

          <Box className="instructions">
            2. Download Standalone Profit and Loss Statement template from this{" "}
            <Link
              to={
                "https://docs.google.com/spreadsheets/d/15PzZApEf5ye-yzwBVgZkkl6yzHX3pGPCHSYcsEc2-6M/edit#gid=0"
              }
              target="_blank"
            >
              <Button variant={"link"} color={"black"}>
                link
              </Button>
            </Link>
          </Box>

          <Box className="instructions">
            3. Select your unit in ₹ only:{" "}
            <Select
              focusBorderColor="primary.400"
              size={"sm"}
              ml={"10px"}
              borderRadius={"10px"}
              w={"120px"}
              onChange={(e) => setUnit(e.target.value)}
              cursor={"pointer"}
              bg={"white"}
              value={unit}
            >
              <option value={""}>--Select--</option>
              {allUnits.map((unit, index) => (
                <option key={index} value={unit.value}>
                  {unit.name}
                </option>
              ))}
            </Select>
          </Box>

          <Box className="instructions">
            4. Fill your details in the Balance Sheet template and upload it to
            the{" "}
            <Button
              variant={"ghost"}
              ml={"5px"}
              p={"4px"}
              onClick={balanceSheetRefOnClickHandler}
              color={"black"}
            >
              Balance Sheet Upload section
            </Button>
          </Box>

          <Box className="instructions">
            5. Fill your details in the Standalone Profit and Loss Statement
            template and upload it to the{" "}
            <Button
              variant={"ghost"}
              ml={"5px"}
              p={"4px"}
              onClick={statementRefOnClickHandler}
              color={"black"}
            >
              Income Statement Upload section
            </Button>
          </Box>
          <Box className="instructions" color={"red.500!important"}>
            *Note: Do not modify any of the template structure provided
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Instructions;
